//Reference: EN055

import { Mappeable } from './mappeable.model';
import * as _ from 'lodash';

export class VisibilityRule extends Mappeable {

    idTypeVisibilityPk: number;
    filterVisibility: string;

    constructor(o) {
        super(o);
    }

    public mapToBack() {
        return {
            filterVisibility: this.filterVisibility,
        }
    }

}